var v1='<div class=lumx-tabs__pane ng-class="{ \'lumx-tabs__pane--is-disabled\': lx.tab.isDisabled }"><div ng-if=lx.isTabActive() ng-transclude></div></div>';
angular.module('lumx.tabs').run(['$templateCache', function ($templateCache) {$templateCache.put('tab.html', v1);}]);
module.exports=v1